import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/shared/api';
import type { SaveSearchRequest } from '@/shared/api';

const LIST_KEY = ['search', 'saved'];

/** Nur die eigenen Vorlagen des Nutzers (tenant+user-scoped serverseitig). */
export function useSavedSearches() {
  const api = useApi();
  const qc = useQueryClient();

  const list = useQuery({
    queryKey: LIST_KEY,
    queryFn: () => api.search.saved.list(),
    staleTime: 30_000,
  });

  const invalidate = () => qc.invalidateQueries({ queryKey: LIST_KEY });

  const create = useMutation({
    mutationFn: (body: SaveSearchRequest) => api.search.saved.create(body),
    onSuccess: invalidate,
  });

  const update = useMutation({
    mutationFn: (input: { id: string; body: SaveSearchRequest }) =>
      api.search.saved.update(input.id, input.body),
    onSuccess: invalidate,
  });

  const remove = useMutation({
    mutationFn: (id: string) => api.search.saved.delete(id),
    onSuccess: invalidate,
  });

  return { list, create, update, remove };
}
